import { schema } from 'normalizr';

const ProductSchema = new schema.Entity('products', {});
const ProductBomSchema = new schema.Entity('productBoms', {});
const ProductInventorySchema = new schema.Entity('productInventories', {});
const ProductInventoryLogSchema = new schema.Entity('productInventoryLogs', {});
const CustomerProductSchema = new schema.Entity('customerProducts', {});
const VendorSchema = new schema.Entity('vendors', {});
const VendorPartSchema = new schema.Entity('vendorParts', {});

export {
  VendorSchema,
  VendorPartSchema,
  CustomerProductSchema,
  ProductSchema,
  ProductBomSchema,
  ProductInventorySchema,
  ProductInventoryLogSchema,
};
